import styled from 'styled-components';

import { DocumentIcon, GearIcon, LogOutIcon, UserHeartIcon, UserPlusIcon } from '../icons';
import { tokens } from '../theme/tokens';
import { Avatar, type UserAvatarView } from './Avatar';
import { ContextMenu } from './ContextMenu';

export const AccountMenuItem = styled(ContextMenu.Item)`
	font-weight: 500;

	svg {
		color: ${tokens.icon.tertiary};
	}

	&:hover,
	&:active {
		color: ${tokens.text.primary};

		svg {
			color: ${tokens.icon.primary};
		}
	}
`;

export const ACCOUNT_MENU_WIDTH = 232;

export const ACCOUNT_MENU_POPOVER_PROPS = {
	horizontalAlign: 'right' as const,
	elevation: 'md' as const,
	offset: tokens.gap.element,
};

export type AccountMenuAccount = {
	id: string;
	user: UserAvatarView;
};

export function AccountMenu(props: {
	accounts?: AccountMenuAccount[];
	onSelectAccount?: (id: string) => void;
	onAddAccount?: () => void;
	onPersonalFiles?: () => void;
	onSettings?: () => void;
	onRecommend?: () => void;
	onLogout?: () => void;
	addAccountLabel: string;
	personalFilesLabel: string;
	settingsLabel: string;
	recommendLabel: string;
	logoutLabel: string;
	showAccounts?: boolean;
	showProfileActions?: boolean;
	showRecommend?: boolean;
}) {
	const showAccounts = Boolean(props.showAccounts);

	return (
		<ContextMenu width={ACCOUNT_MENU_WIDTH}>
			{showAccounts && (
				<>
					<ContextMenu.Group>
						{props.accounts?.map((account) => (
							<AccountMenuItem
								key={account.id}
								icon={<Avatar size={20} user={account.user} />}
								title={`${account.user.firstName} ${account.user.lastName}`}
								onClick={() => props.onSelectAccount?.(account.id)}
							/>
						))}
						<AccountMenuItem
							icon={<UserPlusIcon size={20} />}
							title={props.addAccountLabel}
							onClick={props.onAddAccount}
						/>
					</ContextMenu.Group>
					<ContextMenu.Separator />
				</>
			)}
			{props.showProfileActions && (
				<>
					<ContextMenu.Group>
						<AccountMenuItem
							icon={<DocumentIcon size={20} />}
							title={props.personalFilesLabel}
							onClick={props.onPersonalFiles}
						/>
						<AccountMenuItem
							icon={<GearIcon size={20} />}
							title={props.settingsLabel}
							onClick={props.onSettings}
						/>
						{props.showRecommend && (
							<AccountMenuItem
								icon={<UserHeartIcon size={20} />}
								title={props.recommendLabel}
								onClick={props.onRecommend}
							/>
						)}
					</ContextMenu.Group>
					<ContextMenu.Separator />
				</>
			)}
			<AccountMenuItem
				icon={<LogOutIcon size={20} />}
				title={props.logoutLabel}
				onClick={props.onLogout}
			/>
		</ContextMenu>
	);
}
